// extracted by mini-css-extract-plugin
export var bodyCopy = "bulletedLists-module--bodyCopy--0b4a6";
export var buttons = "bulletedLists-module--buttons--153ad";
export var headline = "bulletedLists-module--headline--eaacd";
export var introText = "bulletedLists-module--introText--1df16";
export var listsWrapper = "bulletedLists-module--listsWrapper--8028f";
export var styledGrid = "bulletedLists-module--styledGrid--0b0e0";
export var styledList = "bulletedLists-module--styledList--967f0";